module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.loaded === 'true') ? _c('div', {
    staticClass: "row rt-main"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.slug,
      staticClass: "medium-12 small-12 column"
    }, [_c('div', {
      staticClass: "rt-post"
    }, [_c('h2', {
      staticClass: "rt-post-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'post',
          params: {
            name: post.slug
          }
        }
      }
    }, [_vm._v(" " + _vm._s(post.title.rendered) + " ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "rt-meta"
    }, [_c('span', {
      staticClass: "posted-on"
    }, [_vm._v("\n\t\t\t\t\t\tPosted On\n\t\t\t\t\t\t"), _c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.formatDate(post))
      }
    })])]), _vm._v(" "), (post.featured_image_src['full'][0]) ? _c('div', {
      staticClass: "progressive full"
    }, [_c('img', {
      directives: [{
        name: "progressive",
        rawName: "v-progressive",
        value: (post.featured_image_src['full'][0]),
        expression: "post.featured_image_src['full'][0]"
      }],
      staticClass: "lazy",
      attrs: {
        "data-srcset": post.featured_image_src['srcset'],
        "src": post.featured_image_src['full'][0]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rt-post-excerpt rt-content",
      domProps: {
        "innerHTML": _vm._s(post.excerpt.rendered)
      }
    })])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42783fc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag.vue
// module id = 131
// module chunks = 0